/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

import { G } from '@2l/utils'

export default {
  isAuthenticated: G('isAuthenticated')
}
